import { useUpdateTimezone } from './useUpdateTimezone'

export { type UpdateTimezoneResponse } from './useUpdateTimezone'

export const timezone = {
  update: useUpdateTimezone,
}
